/* عرض الخصم وإغلاق الباقة */
(function(){
  function s(x){return (typeof x==='string'&&x.trim())?x.trim():null}
  function pad(n){return n<10?('0'+n):String(n)}
  var timer=null;

  function makeCd(iso,host){
    var box=document.createElement('div');
    box.className='cd zk-cd2';
    box.innerHTML='<div class="cdu"><b>00</b><span>يوم</span></div><div class="cdu"><b>00</b><span>ساعة</span></div><div class="cdu"><b>00</b><span>دقيقة</span></div><div class="cdu"><b>00</b><span>ثانية</span></div>';
    host.parentNode.insertBefore(box,host);
    var t=new Date(iso).getTime();
    if(isNaN(t))return box;
    function tick(){
      var d=t-Date.now(); if(d<0)d=0;
      var bs=box.querySelectorAll('b');
      var day=Math.floor(d/86400000),h=Math.floor(d/3600000)%24,m=Math.floor(d/60000)%60,se=Math.floor(d/1000)%60;
      if(bs[0])bs[0].textContent=pad(day);
      if(bs[1])bs[1].textContent=pad(h);
      if(bs[2])bs[2].textContent=pad(m);
      if(bs[3])bs[3].textContent=pad(se);
    }
    tick(); if(timer)clearInterval(timer); timer=setInterval(tick,1000);
    return box;
  }

  function run(){
    var O=(window.ZK&&window.ZK.offer)||{};
    var M=window.ZKM||{};
    var zk=document.getElementById('zk'); if(!zk)return;

    var cd=zk.querySelector('.cd');
    if(!cd&&window.ZKPAGE==='bundle'&&s(M.countdown)){
      var h0=zk.querySelector('.heroC .hcta')||zk.querySelector('.hcta');
      if(h0&&h0.parentNode) cd=makeCd(s(M.countdown),h0);
    }
    if(cd&&cd.parentNode&&!zk.querySelector('.zk-cdl')&&s(O.cd_label)){
      var l=document.createElement('div'); l.className='zk-cdl'; l.textContent=s(O.cd_label);
      cd.parentNode.insertBefore(l,cd);
    }

    var h=zk.querySelector('.hcta');
    if(h&&h.parentNode&&!zk.querySelector('.zk-offer')){
      var t=(window.ZKPAGE==='bundle')?s(O.bundle_note):s(O.note);
      if(t){ var p=document.createElement('p'); p.className='zk-offer'; p.textContent=t;
        h.parentNode.insertBefore(p,h.nextSibling); }
    }

    var b=document.getElementById('bundle');
    if(b&&window.ZKPAGE!=='bundle'&&!b.querySelector('.zk-bandnote')&&s(O.band_note)){
      var btn=b.querySelector('.btn-p');
      if(btn&&btn.parentNode&&btn.parentNode.parentNode){
        var q=document.createElement('p'); q.className='zk-bandnote'; q.textContent=s(O.band_note);
        var host=btn.parentNode;
        host.parentNode.insertBefore(q,host.nextSibling);
      }
    }
  }
  run(); setTimeout(run,700); setTimeout(run,1800);
  window.addEventListener('load',run);
})();
